/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { FinancialInstitutions } from '../models/FinancialInstitutions';
import type { SupportedCountries } from '../models/SupportedCountries';
import type { TaxTypes } from '../models/TaxTypes';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class ConfigurationsService {

    /**
     * Get tax types
     * Returns available tax types which can be used for a tax payment .
     * @returns TaxTypes Available tax types.
     * @throws ApiError
     */
    public static getTaxTypes(
        clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
        public static getTaxTypes(
            clientOptionsOverride?: Partial<ClientOptions>): Promise<TaxTypes>;
            public static getTaxTypes(
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'GET',
                        url: '/public/configurations/tax-types',
                    });
                }

                /**
                 * List of financial institutions for CZ
                 * Returns list of financial institutions for CZ payments.
                 * @returns FinancialInstitutions A list of financial institutions
                 * @throws ApiError
                 */
                public static getFinancialInstitutions(
                    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                    public static getFinancialInstitutions(
                        clientOptionsOverride?: Partial<ClientOptions>): Promise<FinancialInstitutions>;
                        public static getFinancialInstitutions(
                            clientOptionsOverride: Partial<ClientOptions> = {}
                        ) {
                            return __request(
                                {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                                {
                                    method: 'GET',
                                    url: '/public/configurations/financial-institutions',
                                });
                            }

                            /**
                             * List of supported countries for payments
                             * Returns list of supported countries for payments.
                             * @returns SupportedCountries A list of supported countries.
                             * @throws ApiError
                             */
                            public static getSupportedCountries({
                                order,
                            }: {
                                /**
                                 * Specifies the order in which countries should be returned.
                                 */
                                order?: 'ASC' | 'DESC' | 'MOST_USED_ASC'
                            },
                            clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                            public static getSupportedCountries({
                                order,
                            }: {
                                /**
                                 * Specifies the order in which countries should be returned.
                                 */
                                order?: 'ASC' | 'DESC' | 'MOST_USED_ASC'
                            },
                            clientOptionsOverride?: Partial<ClientOptions>): Promise<SupportedCountries>;
                            public static getSupportedCountries({
                                order
                            }: {
                                /**
                                 * Specifies the order in which countries should be returned.
                                 */
                                order?: 'ASC' | 'DESC' | 'MOST_USED_ASC',
                            },
                            clientOptionsOverride: Partial<ClientOptions> = {}
                        ) {
                            return __request(
                                {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                                {
                                    method: 'GET',
                                    url: '/public/configurations/supported-countries',
                                    query: {
                                        'order': order,
                                    },
                                });
                            }

                        }
